import * as React from 'react';
import { Field } from 'formik';
import PhoneInput from 'react-phone-number-input';

import { FieldError } from './FieldError';

export class PhoneNumberField extends React.Component {
  render() {
    return (
      <Field name={this.props.name}>
        {(fieldProps) => {
          const { label, placeholder, ...inputProps } = this.props;
          return (
            <label className="phone-number-field">
              <span
                className={`phone-number-field__label ${label && !!fieldProps.field.value ? 'visible' : ''} ${
                  this.props.disabled ? 'disabled' : ''
                }`}
              >
                {label}
              </span>
              <PhoneInput
                id={this.props.id}
                placeholder={placeholder}
                inputProps={{ ...inputProps }}
                value={fieldProps.field.value}
                onChange={(phone) => fieldProps.form.setFieldValue(this.props.name, phone)}
              />
              <FieldError name={this.props.name} />
            </label>
          );
        }}
      </Field>
    );
  }
}
